export function module_index() {
  $(function() {
    // リサイズ用関数の定義
    function topContents() {
      // メインビジュアルの画像を背景として指定
      $('.mainVisualBg__item img').each(function() {
        // メインビジュアルのsrcを取得
        var mainSrc = 'url(' + $(this).attr('src') + ')';
        // 取得したsrcを親の要素の背景として指定
        $(this).parents(".mainVisualBg__item").css("background-image", mainSrc);
      });

      // スライダーが既に初期化されているか確認
      if ($(".mainVisualBg").hasClass('slick-initialized')) {
        // スライダーの設定を更新する（破棄はしない）
        $(".mainVisualBg").slick('setPosition');
      } else {
        // 初めての初期化
        $(".mainVisualBg").slick({
          autoplay: true,
          autoplaySpeed: 3500,
          dots: false,
          infinite: true,
          speed: 1800,
          arrows: false,
          pauseOnHover: false,
          fade: true,
        });
      }
    }
    
    // 初期実行
    topContents();
    
    // リサイズ処理
    var timer = false;
    var winWidth = $(window).width();
    var winHeight = $(window).height();
    
    $(window).on("resize", function() {
      // リサイズ中の連続実行を防止
      if (timer !== false) {
        clearTimeout(timer);
      }
      
      // 指定時間後に処理を実行
      timer = setTimeout(function() {
        // リサイズ後のウインドウのサイズを取得
        const winWidth_resized = $(window).width();
        const winHeight_resized = $(window).height();
        
        // サイズが変わった場合のみ処理を実行
        if (winWidth !== winWidth_resized || winHeight !== winHeight_resized) {
          topContents();
          
          // 次回比較用にサイズを更新
          winWidth = winWidth_resized;
          winHeight = winHeight_resized;
        }
      }, 200);
    });
  });
}